import {
    Component,
    CUSTOM_ELEMENTS_SCHEMA,
    input,
    InputSignal,
    output,
    OutputEmitterRef,
    signal,
    WritableSignal
} from '@angular/core';
import { SortOrder } from '../../../models';

@Component({
    selector: 'app-table-header',
    templateUrl: './table-header.component.html',
    standalone: true,
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    host: {
        class: 'hover:bg-shui-base-2 px-2 pr-3 py-1 cursor-pointer rounded-md flex items-center gap-1 justify-between select-none',
        '[style.min-width]': 'minWidth()',
        '(click)': 'toggleSortDirection()'
    }
})
export class TableHeaderComponent {
    public width: InputSignal<string> = input('1fr');
    public minWidth: InputSignal<string> = input('100px');
    public filterable: InputSignal<boolean> = input(false);
    public sortOrderChanged: OutputEmitterRef<SortOrder | null> = output<SortOrder | null>();

    protected readonly SortOrder = SortOrder;
    protected sortDirection: WritableSignal<SortOrder | null> = signal<SortOrder | null>(null);

    protected toggleSortDirection(): void {
        if (!this.filterable()) {
            return;
        }

        const currentDirection = this.sortDirection();
        if (currentDirection === SortOrder.ASC) {
            this.sortDirection.set(SortOrder.DESC);
        } else if (currentDirection === SortOrder.DESC) {
            this.sortDirection.set(null);
        } else {
            this.sortDirection.set(SortOrder.ASC);
        }

        this.sortOrderChanged.emit(this.sortDirection());
    }
}
